// extracted by mini-css-extract-plugin
module.exports = {"toggle-switch":"ToggleSwitch_toggle-switch__1VEMT","switch":"ToggleSwitch_switch__1QS8v"};